export const FirebaseConfig = {
  apiKey: "AIzaSyAdzWl-cXkGDcdwBCPKK1wF2rcsOdv6eDI",
  authDomain: "question-of-the-day-351712.firebaseapp.com",
  projectId: "question-of-the-day-351712",
  storageBucket: "question-of-the-day-351712.appspot.com",
  messagingSenderId: "600316946628",
  appId: "1:600316946628:web:fb3168eb05c27d54fc0191",
  measurementId: "G-HXH4NKS64B",
};
